import apiClient from "../client";

// GET /api/notifications
// Returns all notifications for the logged-in user, newest first.
export const getNotifications = async () => {
  const response = await apiClient.get("/notifications");
  return response.data;
};

// GET /api/notifications/unread-count
// Returns { count: number } — lightweight, used for bell badge.
export const getUnreadCount = async () => {
  const response = await apiClient.get("/notifications/unread-count");
  return response.data;
};

// PATCH /api/notifications/{id}/read
// Marks a single notification as read.
export const markNotificationRead = async (notificationId) => {
  const response = await apiClient.patch(`/notifications/${notificationId}/read`);
  return response.data;
};

// PATCH /api/notifications/read-all
// Marks all unread notifications as read for the current user.
export const markAllNotificationsRead = async () => {
  const response = await apiClient.patch("/notifications/read-all");
  return response.data;
};